(function () {
  const SECTION_ID = 'nosto-megamenu-product-card';
  const RETRY_DELAYS_MS = [0, 200, 600, 1200, 2500];

  function parseSectionHtml(html) {
    let markup = html.trim();

    try {
      const json = JSON.parse(markup);
      const sectionKey = Object.keys(json).find((key) => key.includes(SECTION_ID));
      if (sectionKey) markup = json[sectionKey];
    } catch (error) {
      // Plain HTML section response
    }

    const template = document.createElement('template');
    template.innerHTML = markup;

    return (
      template.content.querySelector('.nosto-megamenu-card') ||
      template.content.querySelector('.grid-item.grid-product') ||
      template.content.querySelector('[data-product-grid-item]')
    );
  }

  function isCompleteGridCard(root) {
    const gridItem = root.querySelector('[data-product-grid-item]');
    if (!gridItem) return false;

    const handle = gridItem.dataset.productHandle;
    const title = root.querySelector('.grid-product__title')?.textContent?.trim();
    const hasPlaceholder = Boolean(root.querySelector('.product-image--placeholder'));

    return Boolean(handle && title && !hasPlaceholder);
  }

  function needsConversion(dynamicCard) {
    if (dynamicCard.getAttribute('section') === SECTION_ID && isCompleteGridCard(dynamicCard)) {
      return false;
    }

    return !isCompleteGridCard(dynamicCard);
  }

  function getFetchUrl(dynamicCard) {
    const handle = dynamicCard.getAttribute('handle');
    if (handle) {
      const fetchUrl = new URL(`/products/${handle}`, window.location.origin);
      fetchUrl.searchParams.set('section_id', SECTION_ID);
      return fetchUrl;
    }

    const productLink =
      dynamicCard.querySelector('.nosto-pdp-card__image-wrapper[href], .nosto-pdp-card__title[href]') ||
      dynamicCard.querySelector('a[href*="/products/"]');

    if (!productLink) return null;

    const fetchUrl = new URL(productLink.getAttribute('href'), window.location.origin);
    fetchUrl.searchParams.set('section_id', SECTION_ID);
    return fetchUrl;
  }

  function renderMegamenuCard(dynamicCard) {
    if (dynamicCard.dataset.megamenuCardRendered === 'true' || dynamicCard.dataset.megamenuCardLoading === 'true') {
      return;
    }

    if (!needsConversion(dynamicCard)) {
      dynamicCard.dataset.megamenuCardRendered = 'true';
      return;
    }

    const fetchUrl = getFetchUrl(dynamicCard);
    if (!fetchUrl) return;

    dynamicCard.dataset.megamenuCardLoading = 'true';

    fetch(fetchUrl.toString())
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load Nosto megamenu card');
        return response.text();
      })
      .then((html) => {
        const card = parseSectionHtml(html);
        if (!isCompleteGridCard(card)) return;

        dynamicCard.replaceChildren(card);
        dynamicCard.dataset.megamenuCardRendered = 'true';
      })
      .catch(() => {
        dynamicCard.dataset.megamenuCardLoading = 'false';
      });
  }

  function processMegamenuSlots() {
    document.querySelectorAll('.megamenu-nosto-slot nosto-dynamic-card').forEach(renderMegamenuCard);
  }

  let retryTimers = [];

  function scheduleProcess() {
    retryTimers.forEach(clearTimeout);
    retryTimers = RETRY_DELAYS_MS.map((delay) => setTimeout(processMegamenuSlots, delay));
  }

  function registerNostoListeners() {
    if (!window.nostojs) return;

    window.nostojs(function (api) {
      if (typeof api.listen !== 'function') return;
      api.listen('postrender', scheduleProcess);
      api.listen('taggingsent', scheduleProcess);
    });
  }

  function registerMegamenuListeners() {
    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open) return;
        if (!details.closest('.site-nav--is-megamenu')) return;
        if (!details.querySelector('.megamenu-nosto-slot')) return;
        scheduleProcess();
      },
      true
    );

    document.querySelectorAll('.site-nav--is-megamenu').forEach((item) => {
      item.addEventListener('pointerenter', scheduleProcess, { passive: true });
    });
  }

  function init() {
    registerMegamenuListeners();
    registerNostoListeners();
    scheduleProcess();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
